/**
 * One line per machine for the Explorer footer (app-clarity `ide-home`, overview "stale machine
 * data"): "Mac Studio 3 of 4 runs", or "Photon reported 2 h ago" (amber clock) when its status
 * report is older than REPORT_STALE_MS, or "Photon offline".
 */
import { ago, REPORT_STALE_MS } from './inbox-freshness.js'
import type { Machine } from './types.js'

export interface MachineLine {
  tone: 'run' | 'stale' | 'off'
  text: string
}

export function machineLine(
  m: Pick<Machine, 'name' | 'online' | 'caps' | 'reportAt'>,
  now: number,
): MachineLine {
  if (!m.online) return { tone: 'off', text: `${m.name} offline` }
  if (m.reportAt !== undefined && now - m.reportAt > REPORT_STALE_MS)
    return { tone: 'stale', text: `${m.name} reported ${ago(now - m.reportAt)}` }
  return { tone: 'run', text: `${m.name} ${m.caps?.running ?? 0} of ${m.caps?.maxRuns ?? 0} runs` }
}
